import { c as _c } from "react/compiler-runtime";
import { Checkbox } from "@justhome/react-ui";
import { Control, Controller } from "react-hook-form";
import { FieldValues, FormFieldDefinition } from "./interfaces";
export interface CheckboxFieldProps<T extends FieldValues> {
  fieldDefinition: FormFieldDefinition<T>;
  control: Control<T>;
}
const CheckboxField = t0 => {
  const $ = _c(8);
  const {
    fieldDefinition,
    control
  } = t0;
  let t1;
  if ($[0] !== fieldDefinition.label) {
    t1 = t2 => {
      const {
        field,
        fieldState
      } = t2;
      return <Checkbox {...field} size="sm" checked={field.value} errorMessage={fieldState.error?.message} className="max-w-[360px]">{fieldDefinition.label}</Checkbox>;
    };
    $[0] = fieldDefinition.label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== control || $[3] !== fieldDefinition.defaultValue || $[4] !== fieldDefinition.name || $[5] !== fieldDefinition.rules || $[6] !== t1) {
    t2 = <Controller control={control} name={fieldDefinition.name} rules={fieldDefinition.rules} defaultValue={fieldDefinition.defaultValue} render={t1} />;
    $[2] = control;
    $[3] = fieldDefinition.defaultValue;
    $[4] = fieldDefinition.name;
    $[5] = fieldDefinition.rules;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default CheckboxField;